export default __webpack_public_path__ + "static/media/DIR. RAMO JURIDIC.193cb90c.pdf";